import { payment_status_options, payment_type_options } from 'constants';

import { PATIENT_PRACTICE_OPTIONS } from 'components/shared/Filters/lib/filterOptions';

export const DEFAULT_FILTERS = {
  date: {
    type: 'date-range',
    title: 'Created Date',
    icon: 'calendar-mono'
  },
  status: {
    multiple: true,
    queryFn: (_, data) => {
      const searchTerm = data.filters.searchTerm || '';
      return {
        options: payment_status_options.filter((status) =>
          status.label.toLowerCase().includes(searchTerm.toLowerCase())
        )
      };
    },
    queryKey: 'payment_patient_statuses.options',
    title: 'Status',
    icon: 'status-mono',
    allowed_operators: ['is any of', 'is not', 'is']
  },
  type: {
    multiple: true,
    queryFn: (_, data) => {
      const searchTerm = data.filters.searchTerm || '';
      return {
        options: payment_type_options.filter((status) =>
          status.label.toLowerCase().includes(searchTerm.toLowerCase())
        )
      };
    },
    queryKey: 'payment_patient_types.options',
    title: 'Type',
    icon: 'list-unordered-linear',
    allowed_operators: ['is any of', 'is not', 'is']
  },
  amount: {
    type: 'range',
    title: 'Amount',
    icon: 'dollar-square-mono'
  },
  practice: PATIENT_PRACTICE_OPTIONS
};
